export function normalizePhone(local: string): string {
  const digits = local.replace(/\D/g, "");
  if (digits.startsWith("251")) return `+${digits}`;
  if (digits.startsWith("0")) return `+251${digits.slice(1)}`;
  if (digits.length === 9) return `+251${digits}`;
  return local.startsWith("+") ? local : `+${digits}`;
}

export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 6) return phone;
  const tail = digits.slice(-2);
  return `+251 9** *** **${tail}`;
}

/** Strip non-digits and keep the LAST 9 (so +251912345678, 251912345678 and 0912345678 all become 912345678). */
export function toLocalNine(value: string): string {
  return value.replace(/\D/g, "").slice(-9);
}

/** A valid Ethiopian mobile number: exactly 9 digits starting with 9 or 7. */
export function isValidLocalPhone(value: string): boolean {
  return /^[79]\d{8}$/.test(toLocalNine(value));
}

export function formatPhoneInput(value: string): string {
  const digits = toLocalNine(value);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
}
